import { render, staticRenderFns } from "./EQueueScreenModule.vue?vue&type=template&id=1df5f1fb&"
import script from "./EQueueScreenModule.vue?vue&type=script&lang=js&"
export * from "./EQueueScreenModule.vue?vue&type=script&lang=js&"
import style0 from "./EQueueScreenModule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports